import React from 'react';
import { ImageGallery } from 'components/molecules';
import { CustomPanel, Hero, HeroPanel } from 'components/organisms';
import styles from './Showcase.module.css';
import _ from 'lodash';
import { PictureOrVideo } from 'components/atoms';
import classnames from 'classnames';
import { useDeviceClassification } from 'utils';


export const ShowCaseHeader = ({
    HeroSectionTitle,
    HeroSectionSuperscript,
    HeroSectionBlockOverlayColor,
    FeaturedSubpages
}) => {
    const { isDesktop, width } = useDeviceClassification();
    const _height = isDesktop ? '650px' : `100vh`;


    /*
    Adjust fig caption position based on screen size 
    */
    const primaryPanelBackground = (opacity?: number) => `rgba(
        ${HeroSectionBlockOverlayColor?.CodeForR},
         ${HeroSectionBlockOverlayColor?.CodeForG}, 
         ${HeroSectionBlockOverlayColor?.CodeForB}, 
         ${opacity ? opacity : HeroSectionBlockOverlayColor?.CodeForA}
         )`;


    const Images = [{
        backgroundItem: {
            Title: HeroSectionTitle,
            Description: HeroSectionSuperscript,
            Background: `linear-gradient(35deg, ${primaryPanelBackground(1)}, ${primaryPanelBackground(0.5)}`,
        }
    }, ...FeaturedSubpages.map(({ ActiveTag, FeaturedSubPage, Title, HeroSectionImage1, LargeBlockImage }) => {
        const Src = FeaturedSubPage?.HeroSectionImage1?.Src.length ? FeaturedSubPage?.HeroSectionImage1.Src : FeaturedSubPage?.LargeBlockImage?.Src;

        return {
            TagName: ActiveTag?.TagName || Title,
            Alt: ActiveTag?.Title || Title,
            Height: '100%',
            Src: (HeroSectionImage1?.Src || LargeBlockImage?.Src) || Src,
            Width: '100%'
        }
    }
    )];


    const HeroPanels = [{ custom: true, title: HeroSectionTitle, superScript: HeroSectionSuperscript, background: primaryPanelBackground(0.5) },
    ...FeaturedSubpages.map((p) => p)];

    return (
        <div style={{ height: _height, overflow: 'hidden' }}
         className={classnames(styles.showCaseHeroWrapper, { desktopShowCaseHero: isDesktop })}
        >
            {isDesktop ? <div className={styles.showcaseherowrapper}>
                <Hero
                    className="showcase"
                    type="slide"
                    isDesktop={isDesktop}
                    width={width}
                >
                    {HeroPanels.map((p, i) => {
                        const srcTarget = !p.custom && (p.FeaturedSubPage ? p.FeaturedSubPage : p);
                        const Src = srcTarget.HeroSectionImage1?.Src || srcTarget.LargeBlockImage?.Src;
                        const Alt = srcTarget.Alt;

                        return (
                            <HeroPanel
                                className="slide"
                                primary={i === 0 ? true : false}
                                subPage={p.custom ? null : p}
                                active={i === 0 ? true : false}
                                key={`HeroPanel-${i}`}
                                index={i}>

                                {p.custom ?
                                    <CustomPanel
                                        key={`CustomPanel-${i}`}
                                        index={`CustomPanel-${i}`}
                                        id={i}
                                        background={primaryPanelBackground()}
                                        Title={HeroSectionTitle}
                                        HeroSectionSuperscript={HeroSectionSuperscript} />
                                    :
                                    <div className={styles.panelWrapper}>
                                        <PictureOrVideo
                                            key={`PictureOrVideo-${i}`}
                                            isHero
                                            src={Src}
                                            alt={Alt}
                                        />
                                    </div>
                                }
                            </HeroPanel>
                        );
                    })}
                </Hero>
            </div> :
                <ImageGallery overlayContent={HeroPanels} isHero={true} images={Images} />}
        </div>
    )
};



